import { axiosReq } from "utils";
import { NotificationsActions } from "./NotificationsReducer";

export const RegisterFcmToken = (tokken, getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    dispatch(NotificationsActions.RegisterFcmTokenRequest());
    try {
      const response = await axiosReq({
        method: "patch",
        url: `${process.env.REACT_APP_BACKEND_URL}/notifications/fcm-token`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
        data: {
          fcmToken: tokken,
        },
      });
      dispatch(NotificationsActions.RegisterFcmTokenSuccess(response?.data));
    } catch (error) {
      dispatch(
        NotificationsActions.RegisterFcmTokenFailure(
          error?.response?.data?.message || error?.message
        )
      );
    }

    dispatch(ClearAllStates());
  };
};

export const getAllNotifications = (getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    dispatch(NotificationsActions.getNotificationRequest());
    try {
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/notifications`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(NotificationsActions.getNotificationSuccess(response?.data));
    } catch (error) {
      dispatch(
        NotificationsActions.getNotificationFailure(
          error?.response?.data?.message || error?.message
        )
      );
    }

    dispatch(ClearAllStates());
  };
};

export const markAllAsRead = (getToken, get) => {
  return async (dispatch) => {
    const token = await getToken();

    dispatch(NotificationsActions.markAllAsReadRequest());
    try {
      const response = await axiosReq({
        method: "patch",
        url: `${process.env.REACT_APP_BACKEND_URL}/notifications/mark-all-as-read`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(NotificationsActions.markAllAsReadSuccess(response?.data));
      get && dispatch(getSampleNotification(getToken));
    } catch (error) {
      dispatch(
        NotificationsActions.markAllAsReadFailure(
          error?.response?.data?.message || error?.message
        )
      );
    }

    dispatch(ClearAllStates());
  };
};

export const getSampleNotification = (getToken) => {
  return async (dispatch) => {
    const token = await getToken();

    dispatch(NotificationsActions.getSampleNotificationRequest());
    try {
      const response = await axiosReq({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/notifications/sample`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      dispatch(
        NotificationsActions.getSampleNotificationSuccess(response?.data)
      );
    } catch (error) {
      dispatch(
        NotificationsActions.getSampleNotificationFailure(
          error?.response?.data?.message || error?.message
        )
      );
    }

    dispatch(ClearAllStates());
  };
};

export const ClearAllStates = () => async (dispatch) => {
  setTimeout(() => {
    dispatch(NotificationsActions.clearStates());
  }, 3000);
};
